import { Container, Row, Col, CardBody,  Label, Input, Button,Card,CardTitle,CardText,Table } from "reactstrap";
import { Link } from "react-router-dom";
import React,{useState,useEffect} from "react";
import ReactApexChart from "react-apexcharts";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
import FeatherIcon from "feather-icons-react"
//Import Components
import MiniWidget from "./mini-widget";
import SalesAnalyticsChart from "./salesanalytics-chart";
import TopProduct from "./topselling-product";
import TopUser from "./topuser";
import RecentActivity from "./recent-activity";
import SocialSource from "./socialsource";
import LatestTransaction from "./latest-transaction";
import Slidewithfade from "../Ui/CarouselTypes/slidewithfade";
//Import Image
import { makeStyles } from '@material-ui/core/styles';
import setupanalytics from "../../assets/images/setup-analytics-amico.svg";
import axios from "../../axios"
import numeral from "numeral";
import moment from 'moment'
import { Bar } from "react-chartjs-2"
import SimpleBar from "simplebar-react"
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Dashboard = () => {
  const [allpendingpo, setallpendingpo] = useState([])
  const [pendingpo, setpendingpo] = useState('')
 const [pendingsovaluecollections, setpendingsovaluecollections] = useState([])
 const [pendingsovalue, setpendingsovalue] = useState('')
const [pendingpovalue, setpendingpovalue] = useState('')
const [pendingpovaluecollections, setpendingpovaluecollections] = useState([])
const [pendinsocollect, setpendinsocollect] = useState([])
const [sopending, setsopending] = useState('')
const [purchasechart, setpurchasechart] = useState(1099)
const [allmonthwisesovaluechart, setallmonthwisesovaluechart] = useState([])
const [janso, setjanso] = useState('')
const [febso, setfebso] = useState('')
const [marso, setmarso] = useState('')
const [aprso, setaprso] = useState('')
const [mayso, setmayso] = useState('')
const [junso, setjunso] = useState('')
const [julso, setjulso] = useState('')
const [augso, setaugso] = useState('')
const [sepso, setsepso] = useState('')
const [octso, setoctso] = useState('')
const [novso, setnovso] = useState('')
const [decso, setdecso] = useState('')
const [allpochartvalue, setallpochartvalue] = useState([])
const [janpo, setjanpo] = useState('')
const [febpo, setfebpo] = useState('')
const [marchpo, setmarchpo] = useState('')
const [aprpo, setaprpo] = useState('')
const [maypo, setmaypo] = useState('')
const [junpo, setjunpo] = useState('')
const [julpo, setjulpo] = useState('')
const [augpo, setaugpo] = useState('')
const [seppo, setseppo] = useState('')
const [octpo, setoctpo] = useState('')
const [novpo, setnovpo] = useState('')
const [decpo, setdecpo] = useState('')
const [dailoa1, setdailoa1] = useState(false)

const [allprofitcollections, setallprofitcollections] = useState([])
const [januaryproft, setjanuaryproft] = useState('')
const [feburprofit, setfeburprofit] = useState('')
const [marchprofit, setmarchprofit] = useState('')
const [aprilprofit, setaprilprofit] = useState('')
const [mayprofit, setmayprofit] = useState('')
const [juneprofit, setjuneprofit] = useState('')
const [julyproft, setjulyproft] = useState('')
const [augprofit, setaugprofit] = useState('')
const [sepprofit, setsepprofit] = useState('')
const [octprofit, setoctprofit] = useState('')
const [novprofit, setnovprofit] = useState('')
const [decprofit, setdecprofit] = useState('')
const [alltopsellingproudcts, setalltopsellingproudcts] = useState([])
const [alltoppurchaseorders, setalltoppurchaseorders] = useState([])
const [alltopsalesorders, setalltopsalesorders] = useState([])
const classes = useStyles();
const series = [
  {
    name: "Purchase",
    data: [janpo,febpo,marchpo,aprpo,maypo,junpo,julpo,augpo,seppo,octpo,novpo,decpo],
  },
  {
    name: "Sales",
  
    data: [janso,febso,marso,aprso,mayso,junso,julso,augso,sepso,octso,novso,decso],
  },
  
];
const options = {
  chart: {
    toolbar: {
      show: !1,
    },
  },
  plotOptions: {
    bar: {
      horizontal: !1,
      columnWidth: '45%',
      endingShape: 'rounded'
    },
  },
  dataLabels: {
    enabled: !1
  },
  stroke: {
    show: !0,
    width: 2,
    colors: ['transparent']
  },
  series: [{
    name: 'Net Profit',
    data: [22, 57, 59, 54, 62, 58, 64, 60, 66]
  }, {
    name: 'Revenue',
    data: [74, 83, 102, 97, 86, 106, 93, 114, 94]
  }, {
    name: 'Free Cash Flow',
    data: [37, 42, 38, 26, 47, 50, 54, 55, 43]
  }],
  colors: ['#f1b44c', '#5b73e8', '#34c38f'],
  xaxis: {
    categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct','Nov','Dec'],
  },
  yaxis: {
    title: {
      text: ''
    }
  },
  grid: {
    borderColor: '#f1f1f1',
  },
  fill: {
    opacity: 1

  },
  tooltip: {
    y: {
      formatter: function (val) {
        return "₹" + val + " ";
      }
    }
  }
};
const data = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug","Sep","Oct","Nov","Dec"],
  datasets: [
    {
      label: "Profit",
      backgroundColor: "rgba(52, 195, 143, 0.8)",
      borderColor: "rgba(52, 195, 143, 0.8)",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(52, 195, 143, 0.9)",
      hoverBorderColor: "rgba(52, 195, 143, 0.9)",
      data: [januaryproft,feburprofit,marchprofit,aprilprofit,mayprofit,juneprofit,julyproft,augprofit,sepprofit,octprofit,novprofit,decprofit],
    },
  ],
}

const option = {
  scales: {
    xAxes: [
      {
        barPercentage: 0.4,
      },
    ],
  },
}

  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
  useEffect(() => {
    Getpendingpovalue()
   Getallpendingpos()
   Getpendingsovalue()
   Getpendingso()
   Getmonthwisechartvalue()
   Getmonthwpochartvalue()
   Getallprofit()
   Getalltopsellingproducts()
   getalltoppurchseorder()
   gettopsalesorders()
   setdailoa1(true)
   setTimeout(() => {
    
   setdailoa1(false)
   }, 3000);
   }, [])
   
   const Getallprofit = async() => {
    const get= await axios.instance.get('/Getallprofitdashboard',{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
   
    }}).then((res) => {
     //console.log(res.data)
      for(const data of res.data) {
        //console.log(data,)
        setjanuaryproft(Math.round(data.JanS - data.JanP))
        setfeburprofit(Math.round(data.FebS - data.FebP))
        setmarchprofit(Math.round(data.MarchS - data.MarchP))
        setaprilprofit(Math.round(data.AprilS - data.AprilP))
     
        setjuneprofit(Math.round(data.JuneS - data.JuneP))
        setjulyproft(Math.round(data.JulyS - data.JulyP))
        setaugprofit(Math.round(data.AugestS - data.AugestP))
        setsepprofit(Math.round(data.SeptS - data.SeptP))
        setoctprofit(Math.round(data.OctS - data.OctP))
        setnovprofit(Math.round(data.NovS - data.NovP))
        setdecprofit(Math.round(data.DecS - data.DecP))
        //console.log(data.MayS - data.MayP,'rrde',data.MayS,data.MayP)
        setmayprofit(Math.round(data.MayS - data.MayP))
     }
  
    setallprofitcollections(res.data)
    })
    }
    const Getalltopsellingproducts = async() => {
      const get= await axios.instance.get('/Gettopsellingproducts',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      }}).then((res) => {
       ////console.log(res.data)
     
      setalltopsellingproudcts(res.data)
      })
      }
 

   const Getallpendingpos = async() => {
     const get= await axios.instance.get('/Getpendingpo',{ headers: {'Authorization':tokent,
     'Content-Type': 'application/json',
    
     }}).then((res) => {
      ////console.log(res.data)
       for(const data of res.data) {
         setpendingpo(parseFloat(data.pendingpo))
      }
     setallpendingpo(res.data)
     })
     }

     const getalltoppurchseorder = async() => {
      const get= await axios.instance.get('/gettoppurchseorders',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      }}).then((res) => {
       ////console.log(res.data)
     
      setalltoppurchaseorders(res.data)
      })
      }
      
     const gettopsalesorders = async() => {
      const get= await axios.instance.get('/gettopsalesorders',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      }}).then((res) => {
       ////console.log(res.data)
     
      setalltopsalesorders(res.data)
      })
      }

     const Getmonthwisechartvalue = async() => {
      const get= await axios.instance.get('/Getmothwisechartvalue',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      }}).then((res) => {
       ////console.log(res.data)
        for(const data of res.data) {
          setjanso(parseFloat(data.Jan))
      setfebso(parseFloat(data.Feb))
          setmarso(parseFloat(data.March))
          setaprso(parseFloat(data.April))
          setmayso(parseFloat(data.May))
          setjunso(parseFloat(data.June))
          setjulso(parseFloat(data.July))
          setaugso(parseFloat(data.Augest))
          setsepso(parseFloat(data.Sept))
          setoctso(parseFloat(data.Oct))
          setnovso(parseFloat(data.Nov))
          setdecso(parseFloat(data.Dec))
         
       }
      setallmonthwisesovaluechart(res.data)
      })
      }


      const Getmonthwpochartvalue = async() => {
        const get= await axios.instance.get('/Getpurchasechart',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
       
        }}).then((res) => {
         ////console.log(res.data)
          for(const data of res.data) {
            setjanpo(parseFloat(data.Jan))
        setfebpo(parseFloat(data.Feb))
            setmarchpo(parseFloat(data.March))
            setaprpo(parseFloat(data.April))
            setmaypo(parseFloat(data.May))
            setjunpo(parseFloat(data.June))
            setjulpo(parseFloat(data.July))
            setaugpo(parseFloat(data.Augest))
            setseppo(parseFloat(data.Sept))
            setoctpo(parseFloat(data.Oct))
            setnovpo(parseFloat(data.Nov))
            setdecpo(parseFloat(data.Dec))
           
         }
        setallpochartvalue(res.data)
        //console.log(res.data,'puprchasdata')
        })
        }
     const Getpendingsovalue = async() => {
      const get= await axios.instance.get('/Getpendingsovalue',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      }}).then((res) => {
       ////console.log(res.data)
        for(const data of res.data) {
          ////console.log(data)
          setpendingsovalue(parseFloat(data.sopendingvalue))
       }
       setpendingsovaluecollections(res.data)
      })
      }
      const Getpendingpovalue = async() => {
        const get= await axios.instance.get('/Getpendingpovalue',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
       
        }}).then((res) => {
         ////console.log(res.data)
          for(const data of res.data) {
            ////console.log(data)
            setpendingpovalue(parseFloat(data.popendingvalue))
         }
         setpendingpovaluecollections(res.data)
        })
        }
        const Getpendingso= async() => {
          const get= await axios.instance.get('/Getpendingso',{ headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
         
          }}).then((res) => {
           ////console.log(res.data)
            for(const data of res.data) {
              ////console.log(data)
              setsopending(parseFloat(data.pendingso))
           }
           setpendinsocollect(res.data)
          })
          }


 
 
  return (
    <React.Fragment>
      <div className="page-content">
        <Container >
          <Row>
            {/* <Col xl={12}>
              <Card>
                <CardBody>
                 
                  <Slidewithfade />
                </CardBody>
              </Card>
            </Col> */}
     
     <Row>
     <Breadcrumbs  breadcrumbItem="Dashboard" />

            {/* <MiniWidget reports={reports} /> */}
       
       
           
           <Col lg={3} >
              <Card style={{backgroundColor:'#5DA9FF',height:"125px"}} className="border-none text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white font-size-30" style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas  fa-shopping-cart "></i> Purchase Order
                  </p>
                  <CardText>
                <p className="text-white font-size-13" style={{marginTop:"-15px"}}> Today Po / Po Value : {localStorage.getItem('todaypurchaseorders')} /  {numeral(localStorage.getItem('todaypo')).format('0,0.00')}</p>

                <p className="text-white  font-size-13" style={{marginTop:"-10px"}}> Month Value: {numeral(localStorage.getItem('monthwisepo')).format('0,0.00')}</p>
                {/* <p className="text-white  font-size-14">Month Value: {numeral(pendingsovalue).format('0,0.00')}</p> */}
                  </CardText>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{background:'#FF8F96',height:"125px"}} className="border-black text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white" style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas fa-truck"></i> Sales Order
                  </p>
                  <CardText>
                  <p className="text-white font-size-13"  style={{marginTop:"-15px"}}> Today So / So Value : { (localStorage.getItem('Todaysalesorders'))} /  {numeral(localStorage.getItem('todayso')).format('0,0.00')}</p>

                <p className="text-white  font-size-13" style={{marginTop:"-10px"}}> Month Value: {numeral(localStorage.getItem('monthwiseso')).format('0,0.00')}</p>
                  </CardText>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{backgroundColor:'#F1B44C',height:"125px"}} className="border-none text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white"  style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas fa-shopping-cart"></i> Purchase Invoice
                  </p>
                  <CardText>
                <p className="text-white font-size-13" style={{marginTop:"-15px"}} >Today: { localStorage.getItem('todaypurchseinvoice')}</p>
             
                <p className="text-white  font-size-13" style={{marginTop:"-10px"}}>MTD: {numeral(localStorage.getItem('monthpurchseinvoice')).format('0,0.00')}</p>

                  </CardText>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{backgroundColor:"#7474E1",height:"125px"}} className="border-none text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white"  style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas fa-truck"></i> Sales Invoice
                  </p>
                  <CardText>
                <p className="text-white font-size-13"style={{marginTop:"-15px"}} >Today: {localStorage.getItem('todaysalesinvoice')}</p>
             
                <p className="text-white  font-size-13" style={{marginTop:"-10px"}}>MTD: {numeral(localStorage.getItem('monthsalesinvoice')).format('0,0.00')}</p>

                  </CardText>
                </CardBody>
              </Card>
            </Col>
        
          </Row>
          <Row style={{alignItems:"center",justifyContent:"center",alignSelf:"center"}}>
            <Col lg={3}>
              <Card style={{backgroundColor:"#8C7BB7",height:"125px"}} className="border-none text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white"  style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas fa-truck"></i> Pending Sales Order
                  </p>
                  <CardText>
                <p className="text-white font-size-13" style={{marginTop:"-15px"}}>No Of So: {sopending}</p>
             
                <p className="text-white  font-size-13" style={{marginTop:"-10px"}}>Total Value: {numeral(pendingsovalue).format('0,0.00')}</p>

                  </CardText>
                </CardBody>
              </Card>
            </Col>

            <Col lg={3}>
              <Card color="success" style={{height:"125px"}} className="border-success text-white-50">
                <CardBody>
                  <p className="mt-0 mb-4 text-white"  style={{marginTop:"-10px",fontSize:"15px",fontWeight:"bold"}}>
                  <i className="fas fa-shopping-bag"></i> Pending Purchase Order
                  </p>
                  <CardText>
                  <p className="text-white font-size-13" style={{marginTop:"-15px"}}>No Of Po: {pendingpo}</p>
                  {/* <i style={{fontSize:"20px", color:"white"}} className="fas fa-chart-area text-end"></i> */}
             <p className="text-white  font-size-13"  style={{marginTop:"-10px"}}> Total Value : {numeral(pendingpovalue).format('0,0.00')}</p>
           
                  </CardText>
                </CardBody>
              </Card>
            </Col>
      
          </Row>
          <Col xl={7}>

          <Card>
                <CardBody>
                    <div className="float-end">
                   
                    </div>
                    <CardTitle className="mb-4 h4">Purchase & Sales Analytics</CardTitle>
                

                    <div className="mt-3">
                    <ReactApexChart options={options} series={series} type="bar" height={350} className="apex-charts" />
                    </div>
                </CardBody>
            </Card>
             
            </Col>
            <Col xl={5}>
             
              <TopUser />
             
          
             
            </Col>
            <Col  xl={7}>
            <Card>
                <CardBody>
                <Bar width={474} height={300} data={data} options={option} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={5}>    
             <Card>
                <CardBody>
                    <div className="float-end">
                     
                    </div>
                    <h4 className="card-title mb-4">Top Selling Products</h4>
                    {/* <p className="text-end text-primary text-bold" >Quantity</p> */}
                    <SimpleBar style={{ maxHeight: "336px" }}>
                        <div className="table-responsive">
                            <Table className="table-borderless table-centered table-nowrap">
                                <tbody>
                                   {alltopsellingproudcts.map((data,index)=>(
                                    <tr key={index} >
                                     
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">{data.Product_Details_Description}</h6>
                                            <p className="text-bold font-size-13 mb-0">
                                            <FeatherIcon icon="shopping-bag" className="icon-xs icon me-2 " />{data.Brand}</p>
                                        </td>
                                        <td><span className="badge bg-soft-success font-size-12">Active</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />{numeral(data.Net_quantity).format('0.00')} 
                                        </td>
                                    </tr>
                                   ))}
                                  
                                </tbody>
                            </Table>
                        </div>
                    </SimpleBar>
                </CardBody>
            </Card>
            
            </Col>
            <Row >
           
            <Col xl={12}>    
             <Card>
                <CardBody>
                    <div className="float-end">
                     
                    </div>
                    <h4 className="card-title mb-4">Recent Purchase Order</h4>
                    {/* <p className="text-end text-primary text-bold" >Quantity</p> */}
                    <SimpleBar style={{ maxHeight: "336px" }}>
                        <div className="table-responsive">
                        <Table  style={{ maxHeight: "336px" }} className="table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                     
                                        <th>Po No</th>
                                        <th>Po Date</th>

                                        <th>Customer Name</th>
                                        <th>Total Amount</th>
                                        <th>Created By</th>
                                       
                                    </tr>
                                </thead>
                                {alltoppurchaseorders.map((data,index)=>(
                                <tbody key={index}>
                                    <tr>
                                       
                                        <td><Link to="#" className="text-body fw-bold">{data.PO_No}</Link> </td>
                                        <td>{data.trans_date}</td>
                                        <td>
                                        {data.Customer_Name}
                                        </td>
                                        <td>
                                          {numeral(data.total).format('0,0.00')}
                                        </td> 
                                       
                                        <td>
                                        {data.CreatedBy}
                                        </td>
                                        
                                     
                                    </tr>

                                   
                                </tbody>
                                 ))}
                            </Table>
                        </div>
                    </SimpleBar>
                </CardBody>
            </Card>
            
            </Col>
            <Col xl={12}>    
             <Card>
                <CardBody>
                    <div className="float-end">
                     
                    </div>
                    <h4 className="card-title mb-4">Recent Sales Order</h4>
                    {/* <p className="text-end text-primary text-bold" >Quantity</p> */}
                    <SimpleBar style={{ maxHeight: "336px" }}>
                        <div className="table-responsive">
                        <Table  style={{ maxHeight: "336px" }} className="table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                     
                                        <th>Order No</th>
                                        <th>Order Date</th>

                                        <th>Customer Name</th>
                                        <th>Total Amount</th>
                                        <th>Created By</th>
                                      
                                    </tr>
                                </thead>
                                {alltopsalesorders.map((data,index)=>(
                                <tbody key={index}>
                                    <tr>
                                       
                                        <td><Link to="#" className="text-body fw-bold">{data.Order_No}</Link> </td>
                                        <td>{data.trans_date}</td>
                                        <td>
                                        {data.Customer_Name}
                                        </td>
                                        <td>
                                          {numeral(data.total).format('0,0.00')}
                                        </td> 
                                       
                                        <td>
                                        {data.CreatedBy}
                                        </td>
                                     
                                    </tr>

                                   
                                </tbody>
                                 ))}
                            </Table>
                        </div>
                    </SimpleBar>
                </CardBody>
            </Card>
            
            </Col>
        </Row>
          </Row>
      
        </Container>
      </div>
      {dailoa1 ? (
        <Backdrop  open={dailoa1} className={classes.backdrop} >
        <Spinner name="ball-spin-fade-loader"  color='#fafafa' />
  
       </Backdrop>
        ): null}
    </React.Fragment>
  );
};

export default Dashboard;